import React, { createRef } from 'react';

// styling
import './Customer.css';

// constants
import { BACK, CUSTOMER_PAGES } from './constants';

// custom components
import TopToolbar from '../global/subcomponents/topToolbar/TopToolbar';

// mui components and icons
import { Button, TextField } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { ROLE_ADMIN } from '../global/constants';
import { AddAPhoto, Camera } from '@material-ui/icons';
import { Stack } from '@mui/material';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';

class CustomerManualPoint extends React.Component {
  constructor(props) {
    super(props);
    const isIOSSafari = /iP(ad|hone|od).*Safari/i.test(navigator.userAgent);
    this.state = {
      files: this.getValue('files'),
      newPhotos: [],
      capturedImageURL: null,

      points: '',
      showVideo: false,
      isVerified: false,
      isSubmitting: false,
      //mobile
      isMobile: window.matchMedia('(max-width: 800px)').matches || isIOSSafari,
      isCameraOpen: false,
      cameraFacingMode: 'environment',
    };
    this.videoRef = createRef();
    this.canvasRef = createRef();
  }

  componentWillUnmount() {
    if (this.videoRef.current && this.videoRef.current.srcObject) {
      const stream = this.videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
    }
  }

  componentDidMount() {
    if (this.props !== null && this.props.customer !== null) {
      this.setState({ points: this.props.customer.points ?? '20' });
      if (this.props.customer.files?.[0]?.path) {
        this.props.previewCustomerFile({
          path: this.props.customer.files[0].path,
          accountNumber: this.props.customer.accountNumber,
        });
      }
    }
  }

  handleTakePhotoClick = () => {
    this.setState({ showVideo: true, capturedImageURL: null }, () => {
      this.startWebcam();
    });
  };

  startWebcam = async () => {
    // Check if the ref is available
    if (this.videoRef.current) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        // Ensure the videoRef.current is not null before setting srcObject
        if (this.videoRef.current) {
          this.videoRef.current.srcObject = stream;
          this.videoRef.current.play();
        }
      } catch (err) {
        console.error('Error accessing webcam: ', err);
      }
    } else {
      console.error('Video ref is not available');
    }
  };

  stopCamera = () => {
    const stream = this.videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    this.setState({ showVideo: false });
  };

  captureImage = () => {
    const canvas = this.canvasRef.current;
    const video = this.videoRef.current;
    if (canvas && video) {
      const width = video.videoWidth;
      const height = video.videoHeight;
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, width, height);

      const imageURL = canvas.toDataURL('image/jpeg', 0.5);
      this.setState({ capturedImageURL: imageURL }, () => {
        this.stopCamera();
      });

      this.handleFileAdd(imageURL);
    }
  };

  //camera mobile

  startCameraMobile = async () => {
    try {
      const existing = this.videoRef.current?.srcObject;
      if (existing) {
        existing.getTracks().forEach((track) => track.stop());
      }

      const constraints = {
        video: {
          facingMode: { ideal: this.state.cameraFacingMode },
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
        audio: false,
      };

      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      this.setState({
        isCameraOpen: true,
      });

      if (this.videoRef.current) {
        this.videoRef.current.srcObject = stream;
      }
    } catch (err) {
      alert('Camera access error: ' + err.message);
    }
  };

  switchCameraMobile = () => {
    const nextFacingMode =
      this.state.cameraFacingMode === 'environment' ? 'user' : 'environment';
    this.setState({ cameraFacingMode: nextFacingMode }, () => {
      if (this.state.isCameraOpen) {
        this.startCameraMobile();
      }
    });
  };

  stopCameraMobile = () => {
    const stream = this.videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    this.setState({ isCameraOpen: false });
  };

  capturePhotoMobile = () => {
    const canvas = this.canvasRef.current;
    const video = this.videoRef.current;
    if (canvas && video) {
      const width = video.videoWidth;
      const height = video.videoHeight;
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, width, height);
      const imageURL = canvas.toDataURL('image/jpeg', 0.5);
      this.setState({ capturedImageURL: imageURL }, () => {
        this.stopCameraMobile();
      });
      this.handleFileAdd(imageURL);
    }
  };

  handleOpenCameraMobile = () => {
    if (!this.state.isCameraOpen) {
      this.startCameraMobile();
    }
  };

  //end  camera

  handleFileAdd = async (fileDataURL) => {
    const res = await fetch(fileDataURL);
    const blob = await res.blob();

    const file = new File(
      [blob],
      `${Date.now() + Math.floor(Math.random() * 10000)}.jpeg`,
      { type: blob.type }
    );

    const newFile = await this.getFormattedFileObject(file);

    this.setState({
      newPhotos: newFile,
      capturedImageURL: newFile.localURL,
    });
  };

  getFormattedFileObject = async (file) => {
    return {
      localURL: URL.createObjectURL(file),
      displayName: file.name,
      type: file.type,
      file,
    };
  };

  getValue = (key) => {
    // Check if customer exists first
    if (!this.props.customer) {
      return key === 'files' ? [] : '';
    }

    const value = this.props.customer[key];
    if (value === undefined || value === null || value === '') {
      return key === 'files' ? [] : '';
    }
    return value;
  };

  getStep = () => {
    return this.state.points < 10 ? 5 : 10;
  };

  handlePointsChange = (event) => {
    let value = event.target.value;

    // Prevent negative numbers
    if (value < 0) return;

    // Ensure only numbers are entered, remove leading zeros
    if (value === '' || isNaN(value)) {
      this.setState({ points: '' }); // Allow clearing the input
    } else {
      this.setState({ points: Number(value) });
    }
  };

  savePoints = () => {
    if (this.state.points && !this.state.isSubmitting) {
      this.setState({ isSubmitting: true }); // 🔒 lock the button

      const callback = (error, response) => {
        if (error) {
          this.props.openFeedbackBar('error', error);
        } else {
          this.props.openFeedbackBar('success', response);
        }
        this.setState({ isSubmitting: false }); // 🔓 unlock after response
      };

      this.props.enrollCustomer(
        this.props.customer?.phone,
        this.props.customer?.locationId,
        this.state.points,
        this.state.newPhotos,
        'Manual',
        callback
      );
    }
  };

  getContextualMenuItems = () => {
    let menuItems = [];

    menuItems.push({
      title: BACK,
      icon: <KeyboardBackspaceIcon />,
      onClick: () => {
        this.props.setCurrentPage(CUSTOMER_PAGES.TABLE, {});
      },
    });

    return menuItems;
  };

  render() {
    return (
      <>
        {/*<ErrorFeedbackBar />*/}
        <TopToolbar
          pageName="Set Customer Point"
          menuItems={this.getContextualMenuItems()}
        />

        <div className="rowSpecManualPhoto">
          <div className="card-box">
            <img
              src={this.state.files[0]?.localURL}
              alt="Captured"
              style={{
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                width: '40vw',
                height: '60vh',
              }}
            />
            <h4
              style={{
                marginTop: '18px',
                textAlign: 'center',
                marginBottom: '16px',
              }}
            >
              ID Picture
            </h4>
          </div>

          {!this.state.isMobile ? (
            <div className="card-box">
              {this.state.showVideo ? (
                <video
                  ref={this.videoRef}
                  style={{
                    width: '40vw',
                    height: '60vh',
                  }}
                />
              ) : (
                <div
                  style={{
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px',
                    width: '40vw',
                    height: '60vh',
                    backgroundColor: this.state.capturedImageURL
                      ? 'transparent'
                      : 'gray',
                  }}
                >
                  {this.state.capturedImageURL ? (
                    <img
                      src={this.state.capturedImageURL}
                      alt="Captured"
                      style={{
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        width: '40vw',
                        height: '60vh',
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'gray',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <span style={{ color: 'white' }}>No Image</span>
                    </div>
                  )}
                </div>
              )}

              <canvas ref={this.canvasRef} style={{ display: 'none' }} />

              <Stack
                direction="row"
                spacing={2}
                sx={{ mt: 3, mb: 3 }}
                style={{ marginLeft: '16px', marginRight: '16px' }}
              >
                {!this.state.showVideo && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={this.handleTakePhotoClick}
                    startIcon={<AddAPhoto />}
                    aria-label="Open Camera"
                  >
                    Open Camera
                  </Button>
                )}

                {this.state.showVideo && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<Camera />}
                    onClick={this.captureImage}
                    aria-label="Capture Image"
                  >
                    Capture Image
                  </Button>
                )}

                {this.state.capturedImageURL && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.setState({ isVerified: true })}
                    disabled={!this.state.capturedImageURL}
                    startIcon={<HowToRegIcon />}
                    className="button accept"
                  >
                    Confirm Verification
                  </Button>
                )}
              </Stack>
            </div>
          ) : (
            //is mobile

            <div className="card-box">
              {/* === Image or Placeholder === */}
              {!this.state.isCameraOpen && !this.state.showVideo && (
                <div
                  className="image-container"
                  style={{
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px',
                    width: '100%',
                    height: '300px',
                    objectFit: 'cover',
                    backgroundColor: this.state.capturedImageURL
                      ? 'transparent'
                      : 'gray',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                  }}
                >
                  {this.state.capturedImageURL ? (
                    <img
                      src={this.state.capturedImageURL}
                      alt="Captured"
                      className="responsive-img"
                      style={{
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'gray',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <span style={{ color: 'white' }}>No Image</span>
                    </div>
                  )}
                </div>
              )}

              {/* === Camera Active (Video) === */}
              {this.state.isCameraOpen && (
                <div className="video-container">
                  <video
                    ref={this.videoRef}
                    className="responsive-video"
                    autoPlay
                    playsInline
                    muted
                  />
                  {/* Capture Image */}
                </div>
              )}

              {this.state.isCameraOpen && (
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ mt: 2, justifyContent: 'center' }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<Camera />}
                    onClick={this.capturePhotoMobile}
                    aria-label="Capture Image"
                  >
                    Capture Image
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    startIcon={<FlipCameraIosIcon />}
                    onClick={this.switchCameraMobile}
                    aria-label="Switch Camera"
                  >
                    {this.state.cameraFacingMode === 'environment'
                      ? 'Front'
                      : 'Back'}
                  </Button>
                </Stack>
              )}

              {/* Hidden Canvas */}
              <canvas ref={this.canvasRef} style={{ display: 'none' }} />

              {/* === Action Buttons === */}
              <div className="rowSpecSuppliers" style={{ marginTop: '16px' }}>
                {/* Open Camera */}
                {!this.state.isCameraOpen && !this.state.showVideo && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={this.handleOpenCameraMobile}
                    startIcon={<AddAPhoto />}
                    aria-label="Open Camera"
                  >
                    Open Camera
                  </Button>
                )}

                {/* Confirm Verification */}
                {this.state.capturedImageURL && !this.state.isCameraOpen && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.setState({ isVerified: true })}
                    disabled={!this.state.capturedImageURL}
                    startIcon={<HowToRegIcon />}
                    className="button accept"
                  >
                    Confirm Verification
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>

        <div
          className="card-box"
          style={{ padding: '10px', marginRight: '16px' }}
        >
          <h4 className="card-header">
            {this.props.customer?.firstName} {this.props.customer?.lastName}
          </h4>

          <div className="rowSpec-two">
            <TextField
              className="input-text-field-dashboard"
              variant="outlined"
              label="Points"
              InputLabelProps={{ shrink: true }}
              inputProps={{ min: '0', step: this.getStep() }}
              name="points"
              type="number"
              value={this.state.points}
              disabled={!this.props.user?.authority.includes(ROLE_ADMIN)}
              onChange={this.handlePointsChange}
            />

            <Button
              className="btn-dashboard-point"
              variant="contained"
              color="primary"
              disabled={
                !this.state.points ||
                this.state.points <= 0 ||
                !this.state.isVerified ||
                !this.state.capturedImageURL ||
                this.state.isSubmitting // 🔑 prevent double click
              }
              onClick={() => this.savePoints()}
            >
              {this.state.isSubmitting ? 'Saving...' : 'Set Points'}
            </Button>
          </div>
        </div>
      </>
    );
  }
}

export default CustomerManualPoint;
